define((require) => {
    "use strict";

    const Lightbox = require("shared/ui/common/Lightbox");

    /**
     * Lightbox class used in the viewer only.
     */
    return Lightbox.extend({
        /**
         * The lightbox should be positioned differently than default
         *
         * @type {String}
         * @see  Lightbox#defaultTop
         */
        defaultTop: "40%"
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/imageLibrary/ImageDetailsLightbox.js